export function download(url, filename = undefined) {
  const a = document.createElement('a');
  a.href = url;
  a.setAttribute('download', filename);
  a.click();
}
